import Parse from "parse";
/**
 * This helper checks whether an object is a parse object with specified classname.
 *
 * @param value Any object of Object interface
 * @param className The class name to check against
 * @returns true or false
 */
export function isParseObject(value: Object, className: string): boolean {
  return value instanceof Parse.Object && value.className === className;
}
